<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100">
    <g>
      <path
        d="M31.46,80.88a9.56,9.56,0,1,0,9.64,9.56A9.6,9.6,0,0,0,31.46,80.88Zm0,14.34a4.78,4.78,0,1,1,4.82-4.78A4.8,4.8,0,0,1,31.46,95.22Z"
      />
      <path
        d="M71.65,80.88a9.56,9.56,0,1,0,9.63,9.56A9.6,9.6,0,0,0,71.65,80.88Zm0,14.34a4.78,4.78,0,1,1,4.81-4.78A4.79,4.79,0,0,1,71.65,95.22Z"
      />
      <path
        d="M79.71,71.27a23.15,23.15,0,0,0-8.42-1.55H29.89l-1.26-6.47,51.15-1.51a2.39,2.39,0,0,0,2.3-2h0l3.23-17.2a24,24,0,0,1-4.59.44h-.38l-.6,3.2H65.21l.26-3.88.3-4.47a24.15,24.15,0,0,1-3.35-3.2H44.77l-.51-8.17,13.64.32A24.7,24.7,0,0,1,56.8,22l-36.4-.86-2-10.07a2.4,2.4,0,0,0-2.37-1.93H2.41a2.39,2.39,0,1,0,0,4.78H14.08L16,23.82l.06.28,9.45,48.32a2.41,2.41,0,0,0,2.39,2.08H71.29A18.43,18.43,0,0,1,78,75.71a15.46,15.46,0,0,1,5.29,3.41,2.43,2.43,0,0,0,3.41,0,2.38,2.38,0,0,0,0-3.38A20.07,20.07,0,0,0,79.71,71.27ZM65,49.41H79.14L77.71,57l-13.26.39Q64.72,53.46,65,49.41Zm-3.76,8.12-15,.44c-.17-2.85-.34-5.71-.52-8.56H61.78C61.6,52.09,61.41,54.79,61.23,57.53Zm1.33-19.68-.29,4.29q-.14,2-.27,4.08H45.47l-.25-4.08c-.08-1.43-.17-2.86-.26-4.29ZM21.33,26,41,26.42l.51,8.25H23Zm4,20.26-1.64-8.37H41.75L42,42.33l.24,3.89Zm2.4,12.3-1.78-9.11H42.45c.18,2.88.35,5.77.52,8.65Z"
      />
      <path
        d="M80.72,0A19.13,19.13,0,1,0,100,19.12,19.2,19.2,0,0,0,80.72,0Zm9.15,21.53H83.15v6.66a2.43,2.43,0,0,1-4.86,0V21.53H71.58a2.41,2.41,0,1,1,0-4.82h6.71V10.05a2.43,2.43,0,0,1,4.86,0v6.66h6.72a2.41,2.41,0,1,1,0,4.82Z"
      />
    </g>
  </svg>
</template>


<script>
export default {
  name: 'icon-shoppingcart-add',
  // props: [],
  // components: {},
  // data () {
  //   return {}
  // },
  // methods: {},
  // computed: {},
}
</script>


<style scoped lang="sass">
// @import index

</style>



// WEBPACK FOOTER //
// src/components/icons/icon-shoppingcart-add.vue